import { Component, Prop, Vue } from 'vue-property-decorator';
import NotFoundIcon from '@/components/ui/icons/not-found-icon/not-found-icon.vue';
import { BSpinner } from 'bootstrap-vue';
import OwlSpinner from "@/components/ui/owl-spinner/owlSpinner.vue";
import Box from "@/components/ui/box/box.vue";

@Component({
  components: {
    NotFoundIcon,
    BSpinner,
    OwlSpinner,
    Box,
  }
})
export default class GridSimpleTable extends Vue {
  @Prop({
    required: false,
    default: () => null
  })
  data!: any;

  @Prop({
    required: false,
    default: () => false
  })
  loading!: boolean;
}
